var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card p-3 px-2 px-lg-6" },
    [
      _vm._t("heading", [
        _c("h2", { staticClass: "t-orange ml-12px mb-3" }, [
          _vm._v("Change your password")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticStyle: { padding: "0 12px 12px" } }, [
        _vm.updated
          ? _c("div", { staticClass: "alert alert-success" }, [
              _vm._v("Password updated successfully.")
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.errors && !Array.isArray(_vm.errors)
          ? _c("div", { staticClass: "alert alert-error" }, [
              _vm._v(_vm._s(_vm.errors[Object.keys(_vm.errors)[0]][0]))
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "form",
        { staticClass: "form", attrs: { method: "POST", action: "#" } },
        [
          _vm.errors && Array.isArray(_vm.errors)
            ? _c(
                "div",
                { staticClass: "errors mb-4" },
                [
                  _vm._l(_vm.errors, function(field) {
                    return _vm._l(field, function(error) {
                      return _c("div", { staticClass: "error" }, [
                        _vm._v(_vm._s(error))
                      ])
                    })
                  })
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "account-details d-flex flex-column justify-content-center"
            },
            [
              _c("div", { staticClass: "columns" }, [
                _c("div", { staticClass: "column is-half" }, [
                  _c(
                    "div",
                    {
                      staticClass: "field mb-5",
                      class: { "has-error": _vm.$v.form.currentPassword.$error }
                    },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "label mb-1",
                          attrs: { for: "currentPassword" }
                        },
                        [_vm._v("Current Password*")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "control" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.$v.form.currentPassword.$model,
                              expression: "$v.form.currentPassword.$model",
                              modifiers: { trim: true }
                            }
                          ],
                          staticClass: "input",
                          attrs: {
                            id: "currentPassword",
                            name: "password_confirmation",
                            type: "password"
                          },
                          domProps: {
                            value: _vm.$v.form.currentPassword.$model
                          },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.$v.form.currentPassword,
                                "$model",
                                $event.target.value.trim()
                              )
                            },
                            blur: function($event) {
                              return _vm.$forceUpdate()
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _vm.$v.$dirty && _vm.$v.form.currentPassword.$error
                        ? _c("div", { staticClass: "error" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.getErrorMessage(
                                    _vm.$v.form.currentPassword
                                  )
                                ) +
                                "\n                        "
                            )
                          ])
                        : _vm._e()
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "columns mb-2" }, [
                _c("div", { staticClass: "column is-half" }, [
                  _c(
                    "div",
                    {
                      staticClass: "field mb-5",
                      class: { "has-error": _vm.$v.form.password.$error }
                    },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "label mb-1",
                          attrs: { for: "password" }
                        },
                        [_vm._v("New Password*")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "control" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.$v.form.password.$model,
                              expression: "$v.form.password.$model",
                              modifiers: { trim: true }
                            }
                          ],
                          staticClass: "input",
                          attrs: {
                            id: "password",
                            name: "password",
                            type: "password"
                          },
                          domProps: { value: _vm.$v.form.password.$model },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.$v.form.password,
                                "$model",
                                $event.target.value.trim()
                              )
                            },
                            blur: function($event) {
                              return _vm.$forceUpdate()
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _vm.$v.$dirty && _vm.$v.form.password.$error
                        ? _c("div", { staticClass: "error" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.getErrorMessage(_vm.$v.form.password)
                                ) +
                                "\n                        "
                            )
                          ])
                        : _vm._e()
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "column is-half" }, [
                  _c(
                    "div",
                    {
                      staticClass: "field mb-5",
                      class: {
                        "has-error": _vm.$v.form.passwordConfirmation.$error
                      }
                    },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "label mb-1",
                          attrs: { for: "passwordConfirmation" }
                        },
                        [_vm._v("Confirm New Password*")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "control" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.$v.form.passwordConfirmation.$model,
                              expression: "$v.form.passwordConfirmation.$model",
                              modifiers: { trim: true }
                            }
                          ],
                          staticClass: "input",
                          attrs: {
                            id: "passwordConfirmation",
                            name: "password_confirmation",
                            type: "password"
                          },
                          domProps: {
                            value: _vm.$v.form.passwordConfirmation.$model
                          },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.$v.form.passwordConfirmation,
                                "$model",
                                $event.target.value.trim()
                              )
                            },
                            blur: function($event) {
                              return _vm.$forceUpdate()
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _vm.$v.$dirty && _vm.$v.form.passwordConfirmation.$error
                        ? _c("div", { staticClass: "error" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.getErrorMessage(
                                    _vm.$v.form.passwordConfirmation
                                  )
                                ) +
                                "\n                        "
                            )
                          ])
                        : _vm._e()
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "field d-md-flex justify-content-end px-2 mb-2"
                },
                [
                  !_vm.loading
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-form",
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.submit()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                    Change password\n                "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.loading
                    ? _c("pulse-loader", {
                        attrs: { loading: true, color: "#E57722", size: "20px" }
                      })
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5544971e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5544971e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/settings/ChangePassword.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-5544971e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/settings/ChangePassword.vue
// module chunks = 0 1